import { mapActions } from 'vuex';

const formatMixin = {
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      convertNumberToMoneyFormat: 'GENERAL/convertNumberToMoneyFormat',
    }),
    convertNumber(type) {
      this.convertNumberToMoneyFormat(this[type]).then(res => {
        this[type] = res.data.number;
      });
    },
    formatCurrency(value) {
      value = String(value);
      let preparedValue = parseFloat(value.replace(',', '.')).toFixed(2);
      return preparedValue.replace('.', ',').toLocaleString('pl-PL', {
        useGrouping: 'true',
        minimumFractionDigits: '2',
        maxFractionDigits: '2',
      });
    },
    ucfirst(text) {
      if (!text) {
        return '';
      }
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
export default formatMixin;
